import { Component, OnInit } from '@angular/core';
import { DataService } from '../../providers/data.service';
import { ActivatedRoute } from '@angular/router';
// import {ConfirmationService} from "primeng/api";

@Component({
  selector: 'app-translations',
  templateUrl: './translations.component.html',
  styleUrls: ['./translations.component.scss']
})
export class TranslationsComponent implements OnInit {

  now: string = new Date().toISOString();
  loading: boolean;
  preview_hidden = false;
  show_deleted = false;
  last_fetch: Date;
  primary_lang: string;
  translations: any[];

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute
    // private confirmService: ConfirmationService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if ( !!this.dataService.known_languages) {
        this.primary_lang = this.dataService.known_languages[0].toUpperCase();
      }
      // if(!!params['mode']) this.mode = params.mode;
      this.get_translations();
    });
  }

  _handle_data(result){
    this.loading = false;
    this.last_fetch = new Date();
    this.translations = [];
    for(const key in result){
      this.translations.push({key: key, trans: result[key]});
    }
  }

  get_translations(refresh: boolean = false) {
    this.loading = true;
    this.dataService.get('translation/' + this.primary_lang.toLowerCase()).subscribe(result => {
      this._handle_data(result);
    },
      (err) => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  count_changes(){
    let cnt = 0;
    for(const pr of this.translations){
      if(!!pr._changed) cnt += 1;
    }
    return cnt;
  }

  item_change(item) {
    item._changed = true;
  }

  upload_changes(){
    let trns = {};
    for(const tr of this.translations){
      trns[tr.key] = tr.trans;
    }
    this.loading = true;
    this.dataService.put('translation/' + this.primary_lang.toLowerCase(), trns).subscribe(result=>{
      this._handle_data(result);
    },err =>{
        this.loading = false;
        console.log(err);    })
  }
}





// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/translations/translations.component.ts